import { DeleteDialog } from 'modules/dialog';
import React, { Component } from 'react';
import { Link } from 'react-router';

export default class RowItemLinhVucVanBan extends Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.tenLinhVucVanBan}</li>
          </ul>
        </td>
        <td>
          <div className="todo-wrap two-item">
            <Link className="itt-edit"
              onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)} >Chỉnh sửa</Link>
            <DeleteDialog
              title={'Xoá danh mục'}
              content={'Bạn chắc chắn muốn xoá danh mục này?'}
              redux={this.props.parent}
              deleteId={this.props.item.id}
            />
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-van-ban/datatable/RowItemLinhVucVanBan.jsx